module.exports = __webpack_public_path__ + "img/lazer2.f36ad81a.svg";